var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useRef, useEffect, useState } from 'react';
export function useDebounce(watchedValue, delay) {
    var firstRender = useRef(true);
    var _a = __read(useState(watchedValue), 2), state = _a[0], dispatch = _a[1];
    useEffect(function () {
        if (firstRender.current) {
            firstRender.current = false;
            return function () { };
        }
        var timeoutId = setTimeout(function () { return dispatch(watchedValue); }, delay);
        return function () {
            clearTimeout(timeoutId);
        };
    }, [watchedValue]);
    return state;
}
